import React from "react";
import landingPageArrowLeft from "../../../resources/logo/landing-page-arrow-left.svg";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import f5x7o4x6no1 from "../../../resources/precut-mat-options/5x7/4x6no1-min.jpg";
import f5x7o4x6no2 from "../../../resources/precut-mat-options/5x7/4x6no2-min.jpg";
import f5x7o4x6no3 from "../../../resources/precut-mat-options/5x7/4x6no3-min.jpg";

import f8x10o4x6no1 from "../../../resources/precut-mat-options/8x10/4x6no1-min.jpg";
import f8x10o4x6no2 from "../../../resources/precut-mat-options/8x10/4x6no2-min.jpg";
import f8x10o4x6no3 from "../../../resources/precut-mat-options/8x10/4x6no3-min.jpg";

import f8x10o5x7no1 from "../../../resources/precut-mat-options/8x10/5x7no1-min.jpg";
import f8x10o5x7no2 from "../../../resources/precut-mat-options/8x10/5x7no2-min.jpg";
import f8x10o5x7no3 from "../../../resources/precut-mat-options/8x10/5x7no3-min.jpg";

import f9x9o4x4no1 from "../../../resources/precut-mat-options/9x9/4x4no1-min.jpg";
import f9x9o4x4no2 from "../../../resources/precut-mat-options/9x9/4x4no2-min.jpg";
import f9x9o4x4no3 from "../../../resources/precut-mat-options/9x9/4x4no3-min.jpg";

import f9x9o5x5no1 from "../../../resources/precut-mat-options/9x9/5x5no1-min.jpg";
import f9x9o5x5no2 from "../../../resources/precut-mat-options/9x9/5x5no2-min.jpg";
import f9x9o5x5no3 from "../../../resources/precut-mat-options/9x9/5x5no3-min.jpg";

import f11x14o4x6no1 from "../../../resources/precut-mat-options/11x14/4x6no1-min.jpg";
import f11x14o4x6no2 from "../../../resources/precut-mat-options/11x14/4x6no2-min.jpg";
import f11x14o4x6no3 from "../../../resources/precut-mat-options/11x14/4x6no3-min.jpg";

import f11x14o5x7no1 from "../../../resources/precut-mat-options/11x14/5x7no1-min.jpg";
import f11x14o5x7no2 from "../../../resources/precut-mat-options/11x14/5x7no2-min.jpg";
import f11x14o5x7no3 from "../../../resources/precut-mat-options/11x14/5x7no3-min.jpg";

import f11x14o85x11no1 from "../../../resources/precut-mat-options/11x14/8.5x11no1-min.jpg";
import f11x14o85x11no2 from "../../../resources/precut-mat-options/11x14/8.5x11no2-min.jpg";
import f11x14o85x11no3 from "../../../resources/precut-mat-options/11x14/8.5x11no3-min.jpg";

import f11x14o8x10no1 from "../../../resources/precut-mat-options/11x14/8x10no1-min.jpg";
import f11x14o8x10no2 from "../../../resources/precut-mat-options/11x14/8x10no2-min.jpg";
import f11x14o8x10no3 from "../../../resources/precut-mat-options/11x14/8x10no3-min.jpg";

import f11x14o9x12no1 from "../../../resources/precut-mat-options/11x14/9x12no1-min.jpg";
import f11x14o9x12no2 from "../../../resources/precut-mat-options/11x14/9x12no2-min.jpg";
import f11x14o9x12no3 from "../../../resources/precut-mat-options/11x14/9x12no3-min.jpg";

import f12x16o4x6no1 from "../../../resources/precut-mat-options/12x16/4x6no1-min.jpg";
import f12x16o4x6no2 from "../../../resources/precut-mat-options/12x16/4x6no2-min.jpg";
import f12x16o4x6no3 from "../../../resources/precut-mat-options/12x16/4x6no3-min.jpg";

import f12x16o5x7no1 from "../../../resources/precut-mat-options/12x16/5x7no1-min.jpg";
import f12x16o85x11no1 from "../../../resources/precut-mat-options/12x16/8.5x11no1-min.jpg";
import f12x16o8x10no1 from "../../../resources/precut-mat-options/12x16/8x10no1-min.jpg";
import f12x16o9x12no1 from "../../../resources/precut-mat-options/12x16/9x12no1-min.jpg";

import f12x16o5x7no2 from "../../../resources/precut-mat-options/12x16/5x7no2-min.jpg";
import f12x16o85x11no2 from "../../../resources/precut-mat-options/12x16/8.5x11no2-min.jpg";
import f12x16o8x10no2 from "../../../resources/precut-mat-options/12x16/8x10no2-min.jpg";
import f12x16o9x12no2 from "../../../resources/precut-mat-options/12x16/9x12no2-min.jpg";

import f12x16o5x7no3 from "../../../resources/precut-mat-options/12x16/5x7no3-min.jpg";
import f12x16o85x11no3 from "../../../resources/precut-mat-options/12x16/8.5x11no3-min.jpg";
import f12x16o8x10no3 from "../../../resources/precut-mat-options/12x16/8x10no3-min.jpg";
import f12x16o9x12no3 from "../../../resources/precut-mat-options/12x16/9x12no3-min.jpg";

import f14x18o4x6no1 from "../../../resources/precut-mat-options/14x18/4x6no1-min.jpg";
import f14x18o5x7no1 from "../../../resources/precut-mat-options/14x18/5x7no1-min.jpg";
import f14x18o85x11no1 from "../../../resources/precut-mat-options/14x18/8.5x11no1-min.jpg";
import f14x18o8x10no1 from "../../../resources/precut-mat-options/14x18/8x10no1-min.jpg";
import f14x18o9x12no1 from "../../../resources/precut-mat-options/14x18/9x12no1-min.jpg";

import f14x18o4x6no2 from "../../../resources/precut-mat-options/14x18/4x6no2-min.jpg";
import f14x18o5x7no2 from "../../../resources/precut-mat-options/14x18/5x7no2-min.jpg";
import f14x18o85x11no2 from "../../../resources/precut-mat-options/14x18/8.5x11no2-min.jpg";
import f14x18o8x10no2 from "../../../resources/precut-mat-options/14x18/8x10no2-min.jpg";
import f14x18o9x12no2 from "../../../resources/precut-mat-options/14x18/9x12no2-min.jpg";

import f14x18o4x6no3 from "../../../resources/precut-mat-options/14x18/4x6no3-min.jpg";
import f14x18o5x7no3 from "../../../resources/precut-mat-options/14x18/5x7no3-min.jpg";
import f14x18o85x11no3 from "../../../resources/precut-mat-options/14x18/8.5x11no3-min.jpg";
import f14x18o8x10no3 from "../../../resources/precut-mat-options/14x18/8x10no3-min.jpg";
import f14x18o9x12no3 from "../../../resources/precut-mat-options/14x18/9x12no3-min.jpg";

import f16x20o4x6no1 from "../../../resources/precut-mat-options/16x20/4x6no1.jpg";
import f16x20o5x7no1 from "../../../resources/precut-mat-options/16x20/5x7no1.jpg";
import f16x20o85x11no1 from "../../../resources/precut-mat-options/16x20/85x11no1.jpg";
import f16x20o8x10no1 from "../../../resources/precut-mat-options/16x20/8x10no1.jpg";
import f16x20o9x12no1 from "../../../resources/precut-mat-options/16x20/9x12no1.jpg";
import f16x20o11x14no1 from "../../../resources/precut-mat-options/16x20/11x14no1.jpg";
import f16x20o12x16no1 from "../../../resources/precut-mat-options/16x20/12x16no1.jpg";

import f16x20o4x6no2 from "../../../resources/precut-mat-options/16x20/4x6no2.jpg";
import f16x20o5x7no2 from "../../../resources/precut-mat-options/16x20/5x7no2.jpg";
import f16x20o85x11no2 from "../../../resources/precut-mat-options/16x20/85x11no2.jpg";
import f16x20o8x10no2 from "../../../resources/precut-mat-options/16x20/8x10no2.jpg";
import f16x20o9x12no2 from "../../../resources/precut-mat-options/16x20/9x12no2.jpg";
import f16x20o11x14no2 from "../../../resources/precut-mat-options/16x20/11x14no2.jpg";
import f16x20o12x16no2 from "../../../resources/precut-mat-options/16x20/12x16no2.jpg";

import f16x20o4x6no3 from "../../../resources/precut-mat-options/16x20/4x6no3.jpg";
import f16x20o5x7no3 from "../../../resources/precut-mat-options/16x20/5x7no3.jpg";
import f16x20o85x11no3 from "../../../resources/precut-mat-options/16x20/85x11no3.jpg";
import f16x20o8x10no3 from "../../../resources/precut-mat-options/16x20/8x10no3.jpg";
import f16x20o9x12no3 from "../../../resources/precut-mat-options/16x20/9x12no3.jpg";
import f16x20o11x14no3 from "../../../resources/precut-mat-options/16x20/11x14no3.jpg";
import f16x20o12x16no3 from "../../../resources/precut-mat-options/16x20/12x16no3.jpg";

import f18x24o4x6no1 from "../../../resources/precut-mat-options/18x24/4x6no1.jpg";
import f18x24o5x7no1 from "../../../resources/precut-mat-options/18x24/5x7no1.jpg";
import f18x24o85x11no1 from "../../../resources/precut-mat-options/18x24/85x11no1.jpg";
import f18x24o8x10no1 from "../../../resources/precut-mat-options/18x24/8x10no1.jpg";
import f18x24o9x12no1 from "../../../resources/precut-mat-options/18x24/9x12no1.jpg";
import f18x24o11x14no1 from "../../../resources/precut-mat-options/18x24/11x14no1.jpg";
import f18x24o11x17no1 from "../../../resources/precut-mat-options/18x24/11x17no1.jpg";
import f18x24o12x16no1 from "../../../resources/precut-mat-options/18x24/12x16no1.jpg";
import f18x24o14x18no1 from "../../../resources/precut-mat-options/18x24/12x18no1.jpg";
import f18x24o16x20no1 from "../../../resources/precut-mat-options/18x24/16x20no1.jpg";

import f18x24o4x6no2 from "../../../resources/precut-mat-options/18x24/4x6no2.jpg";
import f18x24o5x7no2 from "../../../resources/precut-mat-options/18x24/5x7no2.jpg";
import f18x24o85x11no2 from "../../../resources/precut-mat-options/18x24/85x11no2.jpg";
import f18x24o8x10no2 from "../../../resources/precut-mat-options/18x24/8x10no2.jpg";
import f18x24o9x12no2 from "../../../resources/precut-mat-options/18x24/9x12no2.jpg";
import f18x24o11x14no2 from "../../../resources/precut-mat-options/18x24/11x14no2.jpg";
import f18x24o11x17no2 from "../../../resources/precut-mat-options/18x24/11x17no2.jpg";
import f18x24o12x16no2 from "../../../resources/precut-mat-options/18x24/12x16no2.jpg";
import f18x24o12x18no2 from "../../../resources/precut-mat-options/18x24/12x18no2.jpg";
import f18x24o16x20no2 from "../../../resources/precut-mat-options/18x24/16x20no2.jpg";

import f18x24o4x6no3 from "../../../resources/precut-mat-options/18x24/4x6no3.jpg";
import f18x24o5x7no3 from "../../../resources/precut-mat-options/18x24/5x7no3.jpg";
import f18x24o85x11no3 from "../../../resources/precut-mat-options/18x24/85x11no3.jpg";
import f18x24o8x10no3 from "../../../resources/precut-mat-options/18x24/8x10no3.jpg";
import f18x24o9x12no3 from "../../../resources/precut-mat-options/18x24/9x12no3.jpg";
import f18x24o11x14no3 from "../../../resources/precut-mat-options/18x24/11x14no3.jpg";
import f18x24o11x17no3 from "../../../resources/precut-mat-options/18x24/11x17no3.jpg";
import f18x24o12x16no3 from "../../../resources/precut-mat-options/18x24/12x16no3.jpg";
import f18x24o12x18no3 from "../../../resources/precut-mat-options/18x24/12x18no3.jpg";
import f18x24o16x20no3 from "../../../resources/precut-mat-options/18x24/16x20no3.jpg";

import f20x20o4x4no1 from "../../../resources/precut-mat-options/20x20/4x4no1.jpg";
import f20x20o5x5no1 from "../../../resources/precut-mat-options/20x20/5x5no1.jpg";
import f20x20o8x8no1 from "../../../resources/precut-mat-options/20x20/8x8no1.jpg";
import f20x20o10x10no1 from "../../../resources/precut-mat-options/20x20/10x10no1.jpg";
import f20x20o12x12no1 from "../../../resources/precut-mat-options/20x20/12x12no1.jpg";
import f20x20o16x16no1 from "../../../resources/precut-mat-options/20x20/16x16no1.jpg";

import f20x20o4x4no2 from "../../../resources/precut-mat-options/20x20/4x4no2.jpg";
import f20x20o5x5no2 from "../../../resources/precut-mat-options/20x20/5x5no2.jpg";
import f20x20o8x8no2 from "../../../resources/precut-mat-options/20x20/8x8no2.jpg";
import f20x20o10x10no2 from "../../../resources/precut-mat-options/20x20/10x10no2.jpg";
import f20x20o12x12no2 from "../../../resources/precut-mat-options/20x20/12x12no2.jpg";
import f20x20o16x16no2 from "../../../resources/precut-mat-options/20x20/16x16no2.jpg";

import f20x20o4x4no3 from "../../../resources/precut-mat-options/20x20/4x4no3.jpg";
import f20x20o5x5no3 from "../../../resources/precut-mat-options/20x20/5x5no3.jpg";
import f20x20o8x8no3 from "../../../resources/precut-mat-options/20x20/8x8no3.jpg";
import f20x20o10x10no3 from "../../../resources/precut-mat-options/20x20/10x10no3.jpg";
import f20x20o12x12no3 from "../../../resources/precut-mat-options/20x20/12x12no3.jpg";
import f20x20o16x16no3 from "../../../resources/precut-mat-options/20x20/16x16no3.jpg";

import f20x28o4x6no1 from "../../../resources/precut-mat-options/20x28/4x6no1.jpg";
import f20x28o5x7no1 from "../../../resources/precut-mat-options/20x28/5x7no1.jpg";
import f20x28o85x11no1 from "../../../resources/precut-mat-options/20x28/85x11no1.jpg";
import f20x28o8x10no1 from "../../../resources/precut-mat-options/20x28/8x10no1.jpg";
import f20x28o9x12no1 from "../../../resources/precut-mat-options/20x28/9x12no1.jpg";
import f20x28o11x14no1 from "../../../resources/precut-mat-options/20x28/11x14no1.jpg";
import f20x28o11x17no1 from "../../../resources/precut-mat-options/20x28/11x17no1.jpg";
import f20x28o12x16no1 from "../../../resources/precut-mat-options/20x28/12x16no1.jpg";
import f20x28o14x18no1 from "../../../resources/precut-mat-options/20x28/14x18no1.jpg";
import f20x28o16x20no1 from "../../../resources/precut-mat-options/20x28/16x20no1.jpg";

import f20x28o4x6no2 from "../../../resources/precut-mat-options/20x28/4x6no2.jpg";
import f20x28o5x7no2 from "../../../resources/precut-mat-options/20x28/5x7no2.jpg";
import f20x28o85x11no2 from "../../../resources/precut-mat-options/20x28/85x11no2.jpg";
import f20x28o8x10no2 from "../../../resources/precut-mat-options/20x28/8x10no2.jpg";
import f20x28o9x12no2 from "../../../resources/precut-mat-options/20x28/9x12no2.jpg";
import f20x28o11x14no2 from "../../../resources/precut-mat-options/20x28/11x14no2.jpg";
import f20x28o11x17no2 from "../../../resources/precut-mat-options/20x28/11x17no2.jpg";
import f20x28o12x16no2 from "../../../resources/precut-mat-options/20x28/12x16no2.jpg";
import f20x28o14x18no2 from "../../../resources/precut-mat-options/20x28/14x18no2.jpg";
import f20x28o16x20no2 from "../../../resources/precut-mat-options/20x28/16x20no2.jpg";

import f20x28o4x6no3 from "../../../resources/precut-mat-options/20x28/4x6no3.jpg";
import f20x28o5x7no3 from "../../../resources/precut-mat-options/20x28/5x7no3.jpg";
import f20x28o85x11no3 from "../../../resources/precut-mat-options/20x28/85x11no3.jpg";
import f20x28o8x10no3 from "../../../resources/precut-mat-options/20x28/8x10no3.jpg";
import f20x28o9x12no3 from "../../../resources/precut-mat-options/20x28/9x12no3.jpg";
import f20x28o11x14no3 from "../../../resources/precut-mat-options/20x28/11x14no3.jpg";
import f20x28o11x17no3 from "../../../resources/precut-mat-options/20x28/11x17no3.jpg";
import f20x28o12x16no3 from "../../../resources/precut-mat-options/20x28/12x16no3.jpg";
import f20x28o14x18no3 from "../../../resources/precut-mat-options/20x28/14x18no3.jpg";
import f20x28o16x20no3 from "../../../resources/precut-mat-options/20x28/16x20no3.jpg";

import f24x36o4x6no1 from "../../../resources/precut-mat-options/24x36/4x6no1.jpg";
import f24x36o5x7no1 from "../../../resources/precut-mat-options/24x36/5x7no1.jpg";
import f24x36o85x11no1 from "../../../resources/precut-mat-options/24x36/85x11no1.jpg";
import f24x36o8x10no1 from "../../../resources/precut-mat-options/24x36/8x10no1.jpg";
import f24x36o9x12no1 from "../../../resources/precut-mat-options/24x36/9x12no1.jpg";
import f24x36o11x14no1 from "../../../resources/precut-mat-options/24x36/11x14no1.jpg";
import f24x36o11x17no1 from "../../../resources/precut-mat-options/24x36/11x17no1.jpg";
import f24x36o12x16no1 from "../../../resources/precut-mat-options/24x36/12x16no1.jpg";
import f24x36o14x18no1 from "../../../resources/precut-mat-options/24x36/14x18no1.jpg";
import f24x36o16x20no1 from "../../../resources/precut-mat-options/24x36/16x20no1.jpg";
import f24x36o16x24no1 from "../../../resources/precut-mat-options/24x36/16x24no1.jpg";
import f24x36o18x24no1 from "../../../resources/precut-mat-options/24x36/18x24no1.jpg";
import f24x36o20x24no1 from "../../../resources/precut-mat-options/24x36/20x24no1.jpg";
import f24x36o20x28no1 from "../../../resources/precut-mat-options/24x36/20x28no1.jpg";
import f24x36o20x30no1 from "../../../resources/precut-mat-options/24x36/20x30no1.jpg";
import f24x36o22x28no1 from "../../../resources/precut-mat-options/24x36/22x28no1.jpg";

import f24x36o4x6no2 from "../../../resources/precut-mat-options/24x36/4x6no2.jpg";
import f24x36o5x7no2 from "../../../resources/precut-mat-options/24x36/5x7no2.jpg";
import f24x36o85x11no2 from "../../../resources/precut-mat-options/24x36/85x11no2.jpg";
import f24x36o8x10no2 from "../../../resources/precut-mat-options/24x36/8x10no2.jpg";
import f24x36o9x12no2 from "../../../resources/precut-mat-options/24x36/9x12no2.jpg";
import f24x36o11x14no2 from "../../../resources/precut-mat-options/24x36/11x14no2.jpg";
import f24x36o11x17no2 from "../../../resources/precut-mat-options/24x36/11x17no2.jpg";
import f24x36o12x16no2 from "../../../resources/precut-mat-options/24x36/12x16no2.jpg";
import f24x36o14x18no2 from "../../../resources/precut-mat-options/24x36/14x18no2.jpg";
import f24x36o16x20no2 from "../../../resources/precut-mat-options/24x36/16x20no2.jpg";
import f24x36o16x24no2 from "../../../resources/precut-mat-options/24x36/16x24no2.jpg";
import f24x36o18x24no2 from "../../../resources/precut-mat-options/24x36/18x24no2.jpg";
import f24x36o20x24no2 from "../../../resources/precut-mat-options/24x36/20x24no2.jpg";
import f24x36o20x28no2 from "../../../resources/precut-mat-options/24x36/20x28no2.jpg";
import f24x36o20x30no2 from "../../../resources/precut-mat-options/24x36/20x30no2.jpg";
import f24x36o22x28no2 from "../../../resources/precut-mat-options/24x36/22x28no2.jpg";

import f24x36o4x6no3 from "../../../resources/precut-mat-options/24x36/4x6no3.jpg";
import f24x36o5x7no3 from "../../../resources/precut-mat-options/24x36/5x7no3.jpg";
import f24x36o85x11no3 from "../../../resources/precut-mat-options/24x36/85x11no3.jpg";
import f24x36o8x10no3 from "../../../resources/precut-mat-options/24x36/8x10no3.jpg";
import f24x36o9x12no3 from "../../../resources/precut-mat-options/24x36/9x12no3.jpg";
import f24x36o11x14no3 from "../../../resources/precut-mat-options/24x36/11x14no3.jpg";
import f24x36o11x17no3 from "../../../resources/precut-mat-options/24x36/11x17no3.jpg";
import f24x36o12x16no3 from "../../../resources/precut-mat-options/24x36/12x16no3.jpg";
import f24x36o14x18no3 from "../../../resources/precut-mat-options/24x36/14x18no3.jpg";
import f24x36o16x20no3 from "../../../resources/precut-mat-options/24x36/16x20no3.jpg";
import f24x36o16x24no3 from "../../../resources/precut-mat-options/24x36/16x24no3.jpg";
import f24x36o18x24no3 from "../../../resources/precut-mat-options/24x36/18x24no3.jpg";
import f24x36o20x24no3 from "../../../resources/precut-mat-options/24x36/20x24no3.jpg";
import f24x36o20x28no3 from "../../../resources/precut-mat-options/24x36/20x28no3.jpg";
import f24x36o20x30no3 from "../../../resources/precut-mat-options/24x36/20x30no3.jpg";
import f24x36o22x28no3 from "../../../resources/precut-mat-options/24x36/22x28no3.jpg";

import colourOptions1 from "../../../resources/precut-mat-options/colourOptions01-min.JPG";
import colourOptions2 from "../../../resources/precut-mat-options/colourOptions2-min.JPG";
import colourOptions3 from "../../../resources/precut-mat-options/colourOptions3-min.JPG";
import colourOptions4 from "../../../resources/precut-mat-options/colourOptions4.JPG";
import colourOptions5 from "../../../resources/precut-mat-options/colourOptions5.PNG";
import colourOptions6 from "../../../resources/precut-mat-options/colourOptions6.JPG";
import colourOptions7 from "../../../resources/precut-mat-options/colourOptions7.JPG";
import colourOptions8 from "../../../resources/precut-mat-options/colourOptions8.JPG";
import colourOptions9 from "../../../resources/precut-mat-options/colourOptions9.JPG";
import colourOptions10 from "../../../resources/precut-mat-options/colourOptions10.JPG";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {MenuItem} from "@material-ui/core";
import displayInputFields from "../app-matsize-rendering/components/displayInputFields";
import arrowUp from "../../../resources/svgIcons/select-mat-arrow-up.svg";
import arrowDown from "../../../resources/svgIcons/select-mat-arrow-down.svg";
import localStorageFunctions from "../comp-localStorage/localStroage";
import {Helmet} from "react-helmet";
import WhatIsMatboard from "../page-howItWorks/whatIsMatboard";
import InstagramLoader from "../page-landing/instagramLoader";
import ReviewComponent from "../app-review/reviewComponent";
import LandingPageReviewStars from "../page-landing/landingPageReviewStars";
import LandingPageFAQ from "../page-landing/landingPageFAQ";
import SatisfactionTransition from "../page-landing/satisfactionTransition";
import PreCutMats from "./preCutMats";
import LazyLoad from "react-lazyload";
import rect1 from "../../../resources/images/landingPage/rect1.png";
import rect2 from "../../../resources/images/landingPage/rect2.png";
import rect3 from "../../../resources/images/landingPage/rect3.png";
import BackingMats from "./backingMats";
import ShopByFrameSize from "./shopByFrameSize";
import DiplomaMats from "./diplomaMats/diplomaMats";

export default class AllMatboards extends React.Component {

    constructor() {
        super();
        this.state = {
            orientation: "portrait",
            frameSize: {
                "5x7": {
                    img: f5x7o4x6no3,
                    img2: f5x7o4x6no1,
                    default: "4x6",
                    width: 5,
                    height: 7,
                    desc: '5x7" Matboard',
                    descDetail: '5x7" Matboards for 5x7" Frames with choice of interior dimensions',
                    descFr: '5x7" Passe-partout',
                    descDetailFr: 'Passepartout 5x7 pouces pour cadres 5x7 pouces avec choix de dimensions intérieures.',
                    priceCAD: 11.95,
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f5x7o4x6no1, f5x7o4x6no2, f5x7o4x6no3]
                        },
                    },
                },
                "9x9": {
                    img: f9x9o4x4no3,
                    img2: f8x10o4x6no1,
                    width: 9,
                    height: 9,
                    desc: '9x9" Matboard',
                    descDetail: '9x9" Matboards for 9x9" Frames with choice of interior dimensions',
                    descFr: '9x9" Passe-partout',
                    descDetailFr: 'Passepartout 9x9 pouces pour cadres 9x9 pouces avec choix de dimensions intérieures.',
                    priceCAD: 13.95,
                    default: "4x4",
                    openSize: {
                        '4x4': {
                            width: 3.75,
                            height: 3.75,
                            desc: '4x4 standard prints',
                            descFr: 'Imprimés standards 4x4',
                            photos: [f9x9o4x4no1, f9x9o4x4no2, f9x9o4x4no3]
                        },
                        '5x5': {
                            width: 4.75,
                            height: 4.75,
                            desc: '5x5 standard prints',
                            descFr: 'Imprimés standards 5x5',
                            photos: [f9x9o5x5no1, f9x9o5x5no2, f9x9o5x5no3]
                        },
                    },
                },
                "8x10": {
                    img: f8x10o4x6no3,
                    img2: f8x10o4x6no1,
                    width: 8,
                    height: 10,
                    desc: '8x10" Matboard',
                    descDetail: '8x10" Matboards for 8x10" Frames with choice of interior dimensions',
                    descFr: '8x10" Passe-partout',
                    descDetailFr: 'Passepartout 8x10 pouces pour cadres 8x10 pouces avec choix de dimensions intérieures.',
                    priceCAD: 13.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f8x10o4x6no1, f8x10o4x6no2, f8x10o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f8x10o5x7no1, f8x10o5x7no2, f8x10o5x7no3]
                        },
                    },
                },
                "11x14": {
                    img: f11x14o4x6no3,
                    img2: f11x14o4x6no1,
                    width: 11,
                    height: 14,
                    default: "4x6",
                    desc: '11x14" Matboard',
                    descDetail: '11x14" Matboards for 11x14" Frames with choice of interior dimensions',
                    descFr: '11x14" Passe-partout',
                    descDetailFr: 'Passepartout 11x14 pouces pour cadres 11x14 pouces avec choix de dimensions intérieures.',
                    priceCAD: 15.95,
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f11x14o4x6no1, f11x14o4x6no2, f11x14o4x6no3],
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f11x14o5x7no1, f11x14o5x7no2, f11x14o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f11x14o8x10no1, f11x14o8x10no2, f11x14o8x10no3],
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter, ANSI-A",
                            descFr: "Papier Lettre, ANSI-A",
                            photos: [f11x14o85x11no1, f11x14o85x11no2, f11x14o85x11no3],
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            desc: 'ARCH-A prints',
                            descFr: 'Imprimés format ARCH-A',
                            photos: [f11x14o9x12no1, f11x14o9x12no2, f11x14o9x12no3],
                        },
                    },
                },
                "12x16": {
                    img: f12x16o4x6no3,
                    img2: f12x16o4x6no1,
                    width: 12,
                    height: 16,
                    desc: '12x16" Matboard',
                    descDetail: '12x16" Matboards for 12x16" Frames with choice of interior dimensions',
                    descFr: '12x16" Passe-partout',
                    descDetailFr: 'Passepartout 12x16 pouces pour cadres 12x16 pouces avec choix de dimensions intérieures.',
                    priceCAD: 17.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f12x16o4x6no1, f12x16o4x6no2, f12x16o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f12x16o5x7no1, f12x16o5x7no2, f12x16o5x7no3],
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f12x16o8x10no1, f12x16o8x10no2, f12x16o8x10no3],
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f12x16o85x11no1, f12x16o85x11no2, f12x16o85x11no3],
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            desc: 'ARCH-A prints',
                            descFr: 'Imprimés format ARCH-A',
                            photos: [f12x16o9x12no1, f12x16o9x12no2, f12x16o9x12no3],
                        },
                    },
                },
                "14x18": {
                    img: f14x18o4x6no3,
                    img2: f14x18o4x6no1,
                    width: 14,
                    height: 18,
                    desc: '14x18" Matboard',
                    descDetail: '14x18" Matboards for 14x18" Frames with choice of interior dimensions',
                    descFr: '14x18" Passe-partout',
                    descDetailFr: 'Passepartout 14x18 pouces pour cadres 14x18 pouces avec choix de dimensions intérieures.',
                    priceCAD: 21.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f14x18o4x6no1, f14x18o4x6no2, f14x18o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f14x18o5x7no1, f14x18o5x7no2, f14x18o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f14x18o8x10no1, f14x18o8x10no2, f14x18o8x10no3]

                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f14x18o85x11no1, f14x18o85x11no2, f14x18o85x11no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            descFr: 'Imprimés standards 8.5x11',
                            desc: "Papier Lettre, ANSI-A",
                            photos: [f14x18o85x11no1, f14x18o85x11no2, f14x18o85x11no3]
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            descFr: 'Imprimés format ARCH-A',
                            desc: 'ARCH-A prints',
                            photos: [f14x18o9x12no1, f14x18o9x12no2, f14x18o9x12no3],
                        },
                    },
                },
                "16x20": {
                    img: f16x20o4x6no3,
                    img2: f16x20o4x6no1,
                    width: 16,
                    height: 20,
                    desc: '16x20" Matboard',
                    descDetail: '16x20" Matboards for 16x20" Frames with choice of interior dimensions',
                    descFr: '16x20" Passe-partout',
                    descDetailFr: 'Passepartout 16x20 pouces pour cadres 16x20 pouces avec choix de dimensions intérieures.',
                    priceCAD: 25.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f16x20o4x6no1, f16x20o4x6no2, f16x20o4x6no3],
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f16x20o5x7no1, f16x20o5x7no2, f16x20o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f16x20o8x10no1, f16x20o8x10no2, f16x20o8x10no3]

                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f16x20o85x11no1, f16x20o85x11no2, f16x20o85x11no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f16x20o85x11no1, f16x20o85x11no2, f16x20o85x11no3]
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            desc: 'ARCH-A prints',
                            descFr: 'Imprimés format ARCH-A',
                            photos: [f16x20o9x12no1, f16x20o9x12no2, f16x20o9x12no3],
                        },
                        '11x14': {
                            width: 10.75,
                            height: 13.75,
                            desc: '11x14 standard prints',
                            descFr: 'Imprimés standards 11x14',
                            photos: [f16x20o11x14no1, f16x20o11x14no2, f16x20o11x14no3]
                        },
                        '11x17': {
                            width: 10.75,
                            height: 16.75,
                            desc: 'ANSI-B, Tabloid, and Ledger prints',
                            descFr: 'Imprimés ANSI-B, Tabloïd et Grand Livre',
                            photos: [f24x36o11x17no1, f24x36o11x17no2, f24x36o11x17no3]
                        },
                        '11.69x16.54': {
                            width: 11.5,
                            height: 16.25,
                            desc: 'A3 prints',
                            descFr: 'Imprimés au Format A3',
                            photos: [f16x20o12x16no1, f16x20o12x16no2, f16x20o12x16no3]
                        },
                        '12x18': {
                            width: 11.75,
                            height: 17.75,
                            desc: 'Mini-Poster prints',
                            descFr: 'Impressions de Mini-Poster',
                            photos: [f16x20o12x16no1, f16x20o12x16no2, f16x20o12x16no3]
                        },
                    },
                },
                "18x24": {
                    img: f18x24o4x6no3,
                    img2: f18x24o4x6no1,
                    width: 18,
                    height: 24,
                    desc: '18x24" Matboard',
                    descDetail: '18x24" Matboards for 18x24" Frames with choice of interior dimensions',
                    descFr: '18x24" Passe-partout',
                    descDetailFr: 'Passepartout 18x24 pouces pour cadres 18x24 pouces avec choix de dimensions intérieures.',
                    priceCAD: 29.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f18x24o4x6no1, f18x24o4x6no2, f18x24o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f18x24o5x7no1, f18x24o5x7no2, f18x24o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f18x24o8x10no1, f18x24o8x10no2, f18x24o8x10no3]
                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f18x24o85x11no1, f18x24o85x11no2, f18x24o85x11no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f18x24o85x11no1, f18x24o85x11no2, f18x24o85x11no3]
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            descFr: 'Imprimés format ARCH-A',
                            desc: 'ARCH-A prints',
                            photos: [f18x24o9x12no1, f18x24o9x12no2, f18x24o9x12no3],
                        },
                        '11x14': {
                            width: 10.75,
                            height: 13.75,
                            descFr: 'Imprimés standards 11x14',
                            desc: '11x14 standard prints',
                            photos: [f18x24o11x14no1, f18x24o11x14no2, f18x24o11x14no3]
                        },
                        '11x17': {
                            width: 10.75,
                            height: 16.75,
                            desc: 'ANSI-B, Tabloid, and Ledger prints',
                            descFr: 'Imprimés ANSI-B, Tabloïd et Grand Livre',
                            photos: [f18x24o11x17no1, f18x24o11x17no2, f18x24o11x17no3]
                        },
                        '11.69x16.54': {
                            width: 11.5,
                            height: 16.25,
                            desc: 'A3 prints',
                            descFr: 'Imprimés au Format A3',
                            photos: [f18x24o11x17no1, f18x24o11x17no2, f18x24o11x17no3]
                        },
                        '12x18': {
                            width: 11.75,
                            height: 17.75,
                            desc: 'Mini-Poster prints',
                            descFr: 'Impressions de Mini-Poster',
                            photos: [f18x24o12x16no1, f18x24o12x16no2, f18x24o12x16no3]
                        },
                        '16x20': {
                            width: 15.75,
                            height: 19.75,
                            desc: 'Portrait Pictures (digital camera picture) prints',
                            descFr: 'Impressions de Photos de Portrait',
                            photos: [f18x24o16x20no1, f18x24o16x20no2, f18x24o16x20no3]

                        },
                    },
                },
                "19.75x19.75": {
                    img: f20x20o4x4no3,
                    img2: f20x20o4x4no1,
                    width: 19.75,
                    height: 19.75,
                    desc: '19.75x19.75" Matboard',
                    descDetail: '19.75x19.75" Matboards for 19.75x19.75" Frames with choice of interior dimensions',
                    descFr: '19.75x19.75" Passe-partout',
                    descDetailFr: 'Passepartout 19.75x19.75 pouces pour cadres 19.75x19.75 pouces avec choix de dimensions intérieures.',
                    priceCAD: 29.95,
                    default: "4x4",
                    openSize: {
                        '4x4': {
                            width: 3.75,
                            height: 3.75,
                            desc: '4x4 standard prints',
                            descFr: 'Imprimés standards 4x4',
                            photos: [f20x20o4x4no1, f20x20o4x4no2, f20x20o4x4no3]
                        },
                        '5x5': {
                            width: 4.75,
                            height: 4.75,
                            desc: '5x5 standard prints',
                            descFr: 'Imprimés standards 5x5',
                            photos: [f20x20o5x5no1, f20x20o5x5no2, f20x20o5x5no3]
                        },
                        '8x8': {
                            width: 7.75,
                            height: 7.75,
                            desc: '8x8 standard prints',
                            descFr: 'Imprimés standards 8x8',
                            photos: [f20x20o8x8no1, f20x20o8x8no2, f20x20o8x8no3]
                        },
                        '10x10': {
                            width: 9.75,
                            height: 9.75,
                            desc: '10x10 standard prints',
                            descFr: 'Imprimés standards 10x10',
                            photos: [f20x20o10x10no1, f20x20o10x10no2, f20x20o10x10no3]
                        },
                        '12x12': {
                            width: 11.75,
                            height: 11.75,
                            desc: '12x12 standard prints',
                            descFr: 'Imprimés standards 12x12',
                            photos: [f20x20o12x12no1, f20x20o12x12no2, f20x20o12x12no3]
                        },
                        '16x16': {
                            width: 15.75,
                            height: 15.75,
                            desc: '16x16 standard prints',
                            descFr: 'Imprimés standards 16x16',
                            photos: [f20x20o16x16no1, f20x20o16x16no2, f20x20o16x16no3]
                        },
                    },
                },
                "20x20": {
                    img: f20x20o4x4no3,
                    img2: f20x20o4x4no1,
                    width: 20,
                    height: 20,
                    desc: '20x20" Matboard',
                    descDetail: '20x20" Matboards for 20x20" Frames with choice of interior dimensions',
                    descFr: '20x20" Passe-partout',
                    descDetailFr: 'Passepartout 20x20 pouces pour cadres 20x20 pouces avec choix de dimensions intérieures.',
                    priceCAD: 29.95,
                    default: "4x4",
                    openSize: {
                        '4x4': {
                            width: 3.75,
                            height: 3.75,
                            desc: '4x4 standard prints',
                            descFr: 'Imprimés standards 4x4',
                            photos: [f20x20o4x4no1, f20x20o4x4no2, f20x20o4x4no3]
                        },
                        '5x5': {
                            width: 4.75,
                            height: 4.75,
                            desc: '5x5 standard prints',
                            descFr: 'Imprimés standards 5x5',
                            photos: [f20x20o5x5no1, f20x20o5x5no2, f20x20o5x5no3]
                        },
                        '8x8': {
                            width: 7.75,
                            height: 7.75,
                            desc: '8x8 standard prints',
                            descFr: 'Imprimés standards 8x8',
                            photos: [f20x20o8x8no1, f20x20o8x8no2, f20x20o8x8no3]
                        },
                        '10x10': {
                            width: 9.75,
                            height: 9.75,
                            desc: '10x10 standard prints',
                            descFr: 'Imprimés standards 10x10',
                            photos: [f20x20o10x10no1, f20x20o10x10no2, f20x20o10x10no3]
                        },
                        '12x12': {
                            width: 11.75,
                            height: 11.75,
                            desc: '12x12 standard prints',
                            descFr: 'Imprimés standards 12x12',
                            photos: [f20x20o12x12no1, f20x20o12x12no2, f20x20o12x12no3]
                        },
                        '16x16': {
                            width: 15.75,
                            height: 15.75,
                            desc: '16x16 standard prints',
                            descFr: 'Imprimés standards 16x16',
                            photos: [f20x20o16x16no1, f20x20o16x16no2, f20x20o16x16no3]
                        },
                    },
                },
                "19.75x27.5": {
                    img: f20x28o4x6no3,
                    img2: f20x28o4x6no1,
                    width: 19.75,
                    height: 27.5,
                    desc: '19.75x27.5" Matboard',
                    descDetail: '19.75x27.5" Matboards for 19.75x27.5" Frames with choice of interior dimensions',
                    descFr: '19.75x27.5" Passe-partout',
                    descDetailFr: 'Passepartout 19.75x27.5 pouces pour cadres 19.75x27.5 pouces avec choix de dimensions intérieures.',
                    priceCAD: 34.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f20x28o4x6no1, f20x28o4x6no2, f20x28o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f20x28o5x7no1, f20x28o5x7no2, f20x28o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f20x28o8x10no1, f20x28o8x10no2, f20x28o8x10no3]
                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f20x28o8x10no1, f20x28o8x10no2, f20x28o8x10no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f20x28o85x11no1, f20x28o85x11no2, f20x28o85x11no3]
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            desc: 'ARCH-A prints',
                            descFr: 'Imprimés format ARCH-A',
                            photos: [f20x28o9x12no1, f20x28o9x12no2, f20x28o9x12no3]
                        },
                        '11x14': {
                            width: 10.75,
                            height: 13.75,
                            desc: '11x14 standard prints',
                            descFr: 'Imprimés standards 11x14',
                            photos: [f20x28o11x14no1, f20x28o11x14no2, f20x28o11x14no3]
                        },
                        '11x17': {
                            width: 10.75,
                            height: 16.75,
                            desc: 'ANSI-B, Tabloid, and Ledger prints',
                            descFr: 'Imprimés ANSI-B, Tabloïd et Grand Livre',
                            photos: [f20x28o11x17no1, f20x28o11x17no2, f20x28o11x17no3]
                        },
                        '11.69x16.54': {
                            width: 11.5,
                            height: 16.25,
                            desc: 'A3 prints',
                            descFr: 'Imprimés au Format A3',
                            photos: [f20x28o11x17no1, f20x28o11x17no2, f20x28o11x17no3]
                        },
                        '12x18': {
                            width: 11.75,
                            height: 17.75,
                            desc: 'Mini-Poster prints',
                            descFr: 'Impressions de Mini-Poster',
                            photos: [f20x28o12x16no1, f20x28o12x16no2, f20x28o12x16no3]
                        },
                        '14x18': {
                            width: 13.75,
                            height: 17.75,
                            desc: '14x18 Standard Prints',
                            descFr: 'Imprimés standards 14x18',
                            photos: [f20x28o14x18no1, f20x28o14x18no2, f20x28o14x18no3]
                        },
                        '16x20': {
                            width: 15.75,
                            height: 19.75,
                            desc: 'Portrait Pictures (digital camera picture) prints',
                            descFr: 'Impressions de Photos de Portrait',
                            photos: [f20x28o16x20no1, f20x28o16x20no2, f20x28o16x20no3]
                        },

                    },
                },
                "20x28": {
                    img: f20x28o4x6no3,
                    img2: f20x28o4x6no1,
                    width: 20,
                    height: 28,
                    desc: '20x28" Matboard',
                    descDetail: '20x28" Matboards for 20x28" Frames with choice of interior dimensions',
                    descFr: '20x28" Passe-partout',
                    descDetailFr: 'Passepartout 20x28 pouces pour cadres 20x28 pouces avec choix de dimensions intérieures.',
                    priceCAD: 34.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f20x28o4x6no1, f20x28o4x6no2, f20x28o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f20x28o5x7no1, f20x28o5x7no2, f20x28o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f20x28o8x10no1, f20x28o8x10no2, f20x28o8x10no3]
                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f20x28o8x10no1, f20x28o8x10no2, f20x28o8x10no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f20x28o85x11no1, f20x28o85x11no2, f20x28o85x11no3]
                        },
                        '9x12': {
                            width: 8.75,
                            height: 11.75,
                            desc: 'ARCH-A prints',
                            descFr: 'Imprimés format ARCH-A',
                            photos: [f20x28o9x12no1, f20x28o9x12no2, f20x28o9x12no3]
                        },
                        '11x14': {
                            width: 10.75,
                            height: 13.75,
                            desc: '11x14 standard prints',
                            descFr: 'Imprimés standards 11x14',
                            photos: [f20x28o11x14no1, f20x28o11x14no2, f20x28o11x14no3]
                        },
                        '11x17': {
                            width: 10.75,
                            height: 16.75,
                            desc: 'ANSI-B, Tabloid, and Ledger prints',
                            descFr: 'Imprimés ANSI-B, Tabloïd et Grand Livre',
                            photos: [f20x28o11x17no1, f20x28o11x17no2, f20x28o11x17no3]
                        },
                        '11.69x16.54': {
                            width: 11.5,
                            height: 16.25,
                            desc: 'A3 prints prints',
                            descFr: 'Imprimés au Format A3',
                            photos: [f20x28o11x17no1, f20x28o11x17no2, f20x28o11x17no3]
                        },
                        '12x18': {
                            width: 11.75,
                            height: 17.75,
                            desc: 'Mini-Poster prints',
                            descFr: 'Impressions de Mini-Poster',
                            photos: [f20x28o12x16no1, f20x28o12x16no2, f20x28o12x16no3]
                        },
                        '14x18': {
                            width: 13.75,
                            height: 17.75,
                            desc: '14x18 Standard Prints',
                            descFr: 'Imprimés standards 14x18',
                            photos: [f20x28o14x18no1, f20x28o14x18no2, f20x28o14x18no3]
                        },
                        '16x20': {
                            width: 15.75,
                            height: 19.75,
                            desc: 'Portrait Pictures (digital camera picture) prints',
                            descFr: 'Impressions de Photos de Portrait',
                            photos: [f20x28o16x20no1, f20x28o16x20no2, f20x28o16x20no3]
                        },

                    },
                },
                "24x35.75": {
                    img: f24x36o4x6no3,
                    img2: f24x36o4x6no1,
                    width: 24,
                    height: 35.75,
                    desc: '24x35.75" Matboard',
                    descDetail: '24x35.75" Matboards for 24x35.75" Frames with choice of interior dimensions',
                    descFr: '24x35.75" Passe-partout',
                    descDetailFr: 'Passepartout 24x35.75 pouces pour cadres 24x35.75 pouces avec choix de dimensions intérieures.',
                    priceCAD: 49.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f24x36o4x6no1, f24x36o4x6no2, f24x36o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f24x36o5x7no1, f24x36o5x7no2, f24x36o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f24x36o8x10no1, f24x36o8x10no2, f24x36o8x10no3]
                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f24x36o85x11no1, f24x36o85x11no2, f24x36o85x11no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f24x36o85x11no1, f24x36o85x11no2, f24x36o85x11no3]
                        },
                        '11x14': {
                            width: 10.75,
                            height: 13.75,
                            desc: '11x14 standard prints',
                            descFr: 'Imprimés standards 11x14',
                            photos: [f24x36o11x14no1, f24x36o11x14no2, f24x36o11x14no3]
                        },
                        '11x17': {
                            width: 10.75,
                            height: 16.75,
                            desc: 'ANSI-B, Tabloid, and Ledger prints',
                            descFr: 'Imprimés ANSI-B, Tabloïd et Grand Livre',
                            photos: [f24x36o11x17no1, f24x36o11x17no2, f24x36o11x17no3]
                        },
                        '11.69x16.54': {
                            width: 11.5,
                            height: 16.25,
                            desc: 'A3 prints',
                            descFr: 'Imprimés au Format A3',
                            photos: [f24x36o11x17no1, f24x36o11x17no2, f24x36o11x17no3]
                        },
                        '12x18': {
                            width: 11.75,
                            height: 17.75,
                            desc: 'Mini-Poster prints',
                            descFr: 'Impressions de Mini-Poster',
                            photos: [f24x36o12x16no1, f24x36o12x16no2, f24x36o12x16no3]
                        },
                        '16x20': {
                            width: 15.75,
                            height: 19.75,
                            descFr: 'Imprimés standards 16x20',
                            desc: 'Portrait Pictures (digital camera picture) prints',
                            photos: [f24x36o16x20no1, f24x36o16x20no2, f24x36o16x20no3]
                        },
                        '16x24': {
                            width: 15.75,
                            height: 23.75,
                            desc: '16x24 standard prints',
                            descFr: 'Imprimés standards 16x24',
                            photos: [f24x36o16x24no1, f24x36o16x24no2, f24x36o16x24no3]
                        },
                        '18x24': {
                            width: 17.75,
                            height: 23.75,
                            desc: 'Architectural C, Medium Poster, and ½ size prints',
                            descFr: 'Architectural C, Affiches De Taille Moyenne Et Imprimés À Moitié De Taille',
                            photos: [f24x36o18x24no1, f24x36o18x24no2, f24x36o18x24no3]
                        },
                        '20x24': {
                            width: 19.75,
                            height: 23.75,
                            desc: '20x24 standard prints',
                            descFr: 'Imprimés standards 20x24',
                            photos: [f24x36o20x24no1, f24x36o20x24no2, f24x36o20x24no3]
                        },
                        '20x28': {
                            width: 19.75,
                            height: 27.75,
                            desc: '20x28 standard prints',
                            descFr: 'Imprimés standards 20x28',
                            photos: [f24x36o20x28no1, f24x36o20x28no2, f24x36o20x28no3]
                        },
                        '20x30': {
                            width: 19.75,
                            height: 29.75,
                            desc: '20x30 standard prints.',
                            descFr: 'Imprimés standards 20x30',
                            photos: [f24x36o20x30no1, f24x36o20x30no2, f24x36o20x30no3]
                        }
                    },
                },
                "24x36": {
                    img: f24x36o4x6no3,
                    img2: f24x36o4x6no1,
                    width: 24,
                    height: 36,
                    desc: '24x36" Matboard',
                    descDetail: '24x36" Matboards for 24x36" Frames with choice of interior dimensions',
                    descFr: '24x36" Passe-partout',
                    descDetailFr: 'Passepartout 24x36 pouces pour cadres 24x36 pouces avec choix de dimensions intérieures.',
                    priceCAD: 49.95,
                    default: "4x6",
                    openSize: {
                        '4x6': {
                            width: 3.75,
                            height: 5.75,
                            desc: '4x6 standard prints',
                            descFr: 'Imprimés standards 4x6',
                            photos: [f24x36o4x6no1, f24x36o4x6no2, f24x36o4x6no3]
                        },
                        '5x7': {
                            width: 4.75,
                            height: 6.75,
                            desc: '5x7 standard prints',
                            descFr: 'Imprimés standards 5x7',
                            photos: [f24x36o5x7no1, f24x36o5x7no2, f24x36o5x7no3]
                        },
                        '8x10': {
                            width: 7.75,
                            height: 9.75,
                            desc: '8x10 standard prints',
                            descFr: 'Imprimés standards 8x10',
                            photos: [f24x36o8x10no1, f24x36o8x10no2, f24x36o8x10no3]
                        },
                        '8.27x11.69': {
                            width: 8,
                            height: 11.5,
                            desc: 'A4 prints',
                            descFr: 'Imprimés au Format A4',
                            photos: [f24x36o85x11no1, f24x36o85x11no2, f24x36o85x11no3]
                        },
                        '8.5x11': {
                            width: 8.25,
                            height: 10.75,
                            desc: "Letter and ANSI-A prints",
                            descFr: 'Papier Lettre, ANSI-A',
                            photos: [f24x36o85x11no1, f24x36o85x11no2, f24x36o85x11no3]
                        },
                        '11x14': {
                            width: 10.75,
                            height: 13.75,
                            desc: '11x14 standard prints',
                            descFr: 'Imprimés standards 11x14',
                            photos: [f24x36o11x14no1, f24x36o11x14no2, f24x36o11x14no3]
                        },
                        '11x17': {
                            width: 10.75,
                            height: 16.75,
                            desc: 'ANSI-B, Tabloid, and Ledger prints',
                            descFr: 'Imprimés ANSI-B, Tabloïd et Grand Livre',
                            photos: [f24x36o11x17no1, f24x36o11x17no2, f24x36o11x17no3]
                        },
                        '11.69x16.54': {
                            width: 11.5,
                            height: 16.25,
                            desc: 'A3 prints',
                            descFr: 'Imprimés au Format A3',
                            photos: [f24x36o11x17no1, f24x36o11x17no2, f24x36o11x17no3]
                        },
                        '12x18': {
                            width: 11.75,
                            height: 17.75,
                            desc: 'Mini-Poster prints',
                            descFr: 'Impressions de Mini-Poster',
                            photos: [f24x36o12x16no1, f24x36o12x16no2, f24x36o12x16no3]
                        },
                        '16x20': {
                            width: 15.75,
                            height: 19.75,
                            descFr: 'Impressions de Photos de Portrait',
                            desc: 'Portrait Pictures (digital camera picture) prints',
                            photos: [f24x36o16x20no1, f24x36o16x20no2, f24x36o16x20no3]
                        },
                        '16x24': {
                            width: 15.75,
                            height: 23.75,
                            desc: '16x24 standard prints',
                            descFr: 'Imprimés standards 16x24',
                            photos: [f24x36o16x24no1, f24x36o16x24no2, f24x36o16x24no3]
                        },
                        '18x24': {
                            width: 17.75,
                            height: 23.75,
                            descFr: 'Architectural C, Affiches De Taille Moyenne Et Imprimés À Moitié De Taille6',
                            desc: 'Architectural C, Medium Poster, and ½ size prints',
                            photos: [f24x36o18x24no1, f24x36o18x24no2, f24x36o18x24no3]
                        },
                        '20x24': {
                            width: 19.75,
                            height: 23.75,
                            desc: '20x24 standard prints',
                            descFr: 'Imprimés standards 20x24',
                            photos: [f24x36o20x24no1, f24x36o20x24no2, f24x36o20x24no3]
                        },
                        '20x28': {
                            width: 19.75,
                            height: 27.75,
                            desc: '20x28 standard prints',
                            descFr: 'Imprimés standards 20x28',
                            photos: [f24x36o20x28no1, f24x36o20x28no2, f24x36o20x28no3]
                        },
                        '20x30': {
                            width: 19.75,
                            height: 29.75,
                            desc: '20x30 standard prints.',
                            descFr: 'Imprimés standards 20x30',
                            photos: [f24x36o20x30no1, f24x36o20x30no2, f24x36o20x30no3]
                        }
                    },
                },
            },
            selectedFrameSize: false,
            selectedOpeningSize: "4x6",
            selectedMatColour: "smoothWhite",
            orderQuantity: 1,
            fetchProductDetail: false,
            fetchDiscountDetail: false,
            fetchShippingInfo: false,
            matboardColourOptions: {
                smoothWhite: {
                    colourName: "Smooth White (Bright White)",
                },
                chinaWhite: {
                    colourName: "China White (Off-White)",
                },
                smoothBlack: {
                    colourName: "Black",
                },
            },
            ikeaFrameNames: {
                "5x7": ["Ribba", "Fiskbo", "Silverhojden", "Edsbruk", "Knoppang", "Vireserum"],
                "8x10": ["Ribba", "Fiskbo", "Himmelsby", "Edsbruk", "Knoppang", "Vireserum"],
                "9x9": ["Ribba", "Knoppang", "Sannahed", "Hovsta"],
                "12x16": ["Ribba", "Knoppang", "Lomviken", "Silverhojden", "Dalskarr", "Virserum", "Edsbruk", "Fiskbo"],
                "16x20": ["Ribba", "Knoppang", "Lomviken", "Edsburk", "Silverhojden", "Fiskbo"],
                "19.75x19.75": ["Ribba"],
                "19.75x27.5": ["Ribba", "Lomviken", "Hovsta", "Fiskbo", "Silverhojden", "Edsbruk", "Knoppang", "Ramsborg"],
                "24x35.75": ["Ribba", "Lomviken", "Hovsta", "Fiskbo", "Silverhojden", "Edsbruk", "Knoppang", "Skatteby"],
            }

        };
    };

    fetchMatboardFAQs() {
        return <div className={"customizable-container"} style={{marginTop: "-100px", background: "white"}}>


        <h2 className={"inspiration-listing-header"}>6. Matboards FAQ - Everything You Need to Know</h2> <br/>
            <main>

                <section>
                    <h2 className={"inspiration-listing-header"}>🖼️ Purpose and Benefits</h2><br/>
                    <h3>Why should I use matboards for my artwork?</h3>
                    <p>Matboards enhance your artwork's presentation and provide crucial protection. They create a clean, professional border and prevent damage caused by direct contact with glass.</p>
                    <h3>What is the purpose of a matboard in framing?</h3>
                    <p>Matboards offer visual breathing room and protect prints from pressing against the glass, giving your framed art a gallery-quality appearance.</p>
                    <br/>

                    <h2 className={"inspiration-listing-header"}>🛡️ Types and Construction</h2>
                    <h3>Are acid-free matboards important?</h3>
                    <p>Yes, acid-free matboards protect against yellowing and degradation. Ours are buffered for archival use, keeping your art safe for decades.</p>
                    <h3>What is a backing board?</h3>
                    <p>A backing board supports the matboard and artwork, ensuring they stay flat and secure inside the frame.</p>
                    <h3>Do you sell 32x40" matboards?</h3>
                    <p>Yes, full-sheet matboards (32x40") are available in a range of colors for large-format or custom projects.</p>
                    <a href={"/32x40-inch-backing-mounting-matboards"} style={{textDecoration: "underline"}}>Order 32x40 inch matboards</a>
                    <h3>Can I get larger matboards?</h3>
                    <p>We currently offer matboards up to 32x40". For oversized art, consider printed borders or linen liners.</p>
                    <h3>What are 4-ply and 8-ply matboards?</h3>
                    <p>4-ply is standard thickness (~1/16"). 8-ply is double-thick (~1/8") and provides extra depth and sturdiness.</p>
                    <h3>Do you offer custom cut matboards?</h3>
                    <p>Yes! You can order custom matboards to match your specific size, color, and window dimensions.</p>
                    <a href={"/customize-matboards"} style={{textDecoration: "underline"}}>Order a Custom Matboard</a>
                    <h3>What does "mat," "matt," or "matte" mean?</h3>
                    <p>All refer to matboards in framing, though "matte" can also describe a non-glossy finish in printing.</p>
                </section>

                <section>
                    <h2 className={"inspiration-listing-header"}>🎨 Colors & Styles</h2><br/>
                    <h3>What is your brightest white matboard?</h3>
                    <p>Our Smooth White matboard is our cleanest, brightest option, perfect for a modern, high-contrast look.</p>
                    <a href={"/colour-guide"} style={{textDecoration: "underline"}}>Read our Color Guide</a>

                    <h3>How do I choose the right color?</h3>
                    <p>Select a matboard that enhances your artwork’s tones. White, black, or grey are versatile choices, while bold colors add contrast and personality.</p>
                    <a href={"/colour-guide"} style={{textDecoration: "underline"}}>Read our Color Guide</a>

                    <h3>How many colors are available?</h3>
                    <p>We carry over 30 matboard colors and can special order additional options upon request.</p>
                    <a href={"/colour-guide"} style={{textDecoration: "underline"}}>Read our Color Guide</a>

                    <h3>Can I see samples before ordering?</h3>
                    <p>Yes! Request a free sample kit to preview your matboard color and texture choices.</p>
                    <a href={"https://docs.google.com/forms/d/1iLljfvNlrLclrYXPgLtki7PDhvSjNUX2DJYFrZpuXjI/edit"} style={{textDecoration: "underline"}}>Order Matboard Samples for Free</a>
                    <br/><br/>

                    <h2 className={"inspiration-listing-header"}>📏 Sizing & Measuring</h2><br/>
                    <h3>How do I choose the right matboard size?</h3>
                    <p>Measure the inside of your frame or glass. The matboard should match those dimensions. For custom frames, measure the back opening of the frame.</p>
                    <a href={"/design-guide"} style={{textDecoration: "underline"}}>Watch our Matboard Sizing Guide</a>

                    <h3>How do I determine the window size?</h3>
                    <p>We recommend a 1/4" overlap on all sides. Use wider borders for smaller prints or to create a dramatic look. Print your artwork with a white margin to avoid cropping important content.</p>
                    <h3>What is a matboard window?</h3>
                    <a href={"/window-size"} style={{textDecoration: "underline"}}>Watch our Window Sizing Guide</a>

                    <p>This is the opening in the matboard where your artwork shows through. It is slightly smaller than the artwork to hold it securely.</p>
                    <h3>How much of the image will be covered?</h3>
                    <p>About 1/4" of each edge will be covered by the matboard to prevent slippage.</p><br/>

                    <h2 className={"inspiration-listing-header"}>➕ Advanced Options</h2><br/>
                    <h3>What is matboard offset?</h3>
                    <p>Offset refers to the intentional overlap between the matboard window and your artwork. We calculate this by default (1/8"–1/4").</p>
                    <a href={"/customize-matboards"} style={{textDecoration: "underline"}}>Order a Custom Matboard</a>
                    <h3>What is double matting?</h3>
                    <p>Double matting adds a secondary matboard under the top mat for extra visual depth and layering.</p>
                    <a href={"/customize-matboards"} style={{textDecoration: "underline"}}>Order a Custom Matboard</a>
                    <h3>Can I customize double matting?</h3>
                    <p>Yes. Choose reveal size and color for the second mat. All mats are beveled unless you request a 90º straight cut.</p>
                    <a href={"/customize-matboards"} style={{textDecoration: "underline"}}>Order a Custom Matboard</a>
                    <h3>Do you cut oval or circular matboards?</h3>
                    <p>Yes! We can cut your matboard or window into circles or ovals — just specify your shape when ordering.</p>
                    <a href={"/customize-matboards"} style={{textDecoration: "underline"}}>Order a Custom Matboard</a>
                    <br/>

                </section>
            </main>
        </div>
    }


    render() {
        return <div>
            <Helmet>
                <title>
                    Custom & Standard Matboards for Photos, Artwork, and Framing | Worldwide Free Shipping Available
                </title>
                <meta name="description" content="Shop custom and standard matboards for photos, artwork, diplomas, and crafts. Choose from uncut, pre-cut, or fully personalized matboard options. Fast shipping worldwide."/>

            </Helmet>

            <div className={`precut-mat-container`}>

                <h1 className={"inspiration-listing-header"} style={{width: "100%", overflow: "auto", textAlign: "center"}}>
                    Our Matboards Products
                </h1>

                <div className={"inspiration-listing-desc"} style={{padding: "50px 0"}}>
                    <LazyLoad>
                        <video className={"what-is-mat-image-v2"} loop="true" autoPlay="autoplay" controls muted
                               src="https://s3.ca-central-1.amazonaws.com/custommat.landing.v2/0_What-is-a-matboard_1920x1290_v1+(1).mp4"></video>
                    </LazyLoad>
                </div>

                <h2 className={"inspiration-listing-header"}>
                    1. Custom cut Matboards<br/>
                </h2>
                <h3 className={"inspiration-listing-desc"} style={{textAlign: "left"}}>
                    <b>Create fully custom matboards in any size, color, or layout.</b><br/><br/>
                    <span style={{textTransform: "none", lineHeight: 2, textAlign: "left"}}>
                        Design your own custom cut matboards to perfectly fit your artwork, photos, or collectibles.
                        Our made-to-order matboards are fully customizable by size, color, and layout — whether you need a single opening or a complex design for jerseys, diplomas, or sports memorabilia.
                        Each matboard is precision-cut to your specifications and delivered straight to your door.
                        Ideal for professional framers, artists, and DIY enthusiasts, our matboards offer a flawless, gallery-quality finish with endless creative possibilities.
                        <br/><br/>
                            Worldwide Free Shipping Available. Fast Shipping & Easy Returns. <br className={"mobile-no-display"}/>
                        </span>
                </h3>

                <div className={"landing-page-bottom-start-button"} style={{width: "200px", marginTop: "50px", marginBottom: "50px", height: "60px"}}>
                    <a href={this.props.french ? "/customize-matboards-fr" : "/customize-matboards"}>
                        <div className={"landing-page-button-standard-v2 how-it-works-page-button"}
                             id={"explainer-start-designing-button"}>
                            {this.props.french ? "Je crée " : "START DESIGNING"}
                        </div>
                    </a>
                </div>


                <div className={"customizable-container"}>
                    <div className={"customizable-subcontainer"}>
                        <div className={"customizable-head"}>
                            Completely Customizable
                        </div>
                        <div className={"customizable-subhead"}>
                            We can trim matboards up to 32 x 40 inches,<br className={"mobile-no-display"}/> and we can add as many <b>interior windows</b> as you want at <b>no extra charge.</b>
                        </div>
                    </div>
                    <div className={"customizable-image-container"}>
                        <img className={"customizable-image customizable-image-left"} src={rect1} />
                        <img className={"customizable-image customizable-image-ctr"} src={rect2} />
                        <img className={"customizable-image customizable-image-right"} src={rect3} />
                    </div>

                </div>

                <div style={{width: "100%", overflow: "auto"}}>
                    <PreCutMats
                        allMatboards={true}
                        showShoppingCartModal={this.props.showShoppingCartModal}
                        language={this.props.language}
                        selectedMatSize={false}
                        fxConversion={this.props.fxConversion}
                        currency={this.props.currency}
                        changeCurrency={this.props.changeCurrency}
                        getDiscountMultiplier={this.props.getDiscountMultiplier}
                        location={this.props.location}
                        onGoingPromotion={this.props.onGoingPromotion}
                        promotionRate={this.props.promotionRate}
                    />

                    <BackingMats
                        allMatboards={true}
                        showShoppingCartModal={this.props.showShoppingCartModal}
                        language={this.props.language}
                        selectedMatSize={false}
                        fxConversion={this.props.fxConversion}
                        currency={this.props.currency}
                        changeCurrency={this.props.changeCurrency}
                        getDiscountMultiplier={this.props.getDiscountMultiplier}
                        location={this.props.location}
                        onGoingPromotion={this.props.onGoingPromotion}
                        promotionRate={this.props.promotionRate}
                    />

                    <ShopByFrameSize
                        allMatboards={true}
                        showShoppingCartModal={this.props.showShoppingCartModal}
                        language={this.props.language}
                        selectedMatSize={false}
                        fxConversion={this.props.fxConversion}
                        currency={this.props.currency}
                        changeCurrency={this.props.changeCurrency}
                        getDiscountMultiplier={this.props.getDiscountMultiplier}
                        location={this.props.location}
                        onGoingPromotion={this.props.onGoingPromotion}
                        promotionRate={this.props.promotionRate}
                    />

                    <DiplomaMats
                        allMatboards={true}
                        showShoppingCartModal={this.props.showShoppingCartModal}
                        language={this.props.language}
                        selectedMatSize={false}
                        fxConversion={this.props.fxConversion}
                        currency={this.props.currency}
                        changeCurrency={this.props.changeCurrency}
                        getDiscountMultiplier={this.props.getDiscountMultiplier}
                        location={this.props.location}
                        onGoingPromotion={this.props.onGoingPromotion}
                        promotionRate={this.props.promotionRate}
                    />

                    {this.fetchMatboardFAQs()}
                </div>
            </div>
        </div>
    }
}